import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"

const PinSvg = ({ onClick, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 51" onClick={onClick} style={style || {}}>
    <path d="M16.7 0h-.4C7.3.1 0 7.4 0 16.5c0 .3 0 1.3.2 2.6.1.8.2 1.5.7 2.6.4 1.1.6 1.7 1.2 2.9C6.6 33.5 14.6 47.8 15 48.5s1.6 2.5 1.6 2.5 1.2-1.8 1.6-2.5 8.4-15 12.9-23.9c.6-1.2.8-1.8 1.2-2.9.4-1.1.6-1.8.7-2.6.2-1.3.2-2.3.2-2.6C33 7.4 25.7.1 16.7 0zm-.2 22.5c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z" />
  </svg>
)

PinSvg.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object
}

export function MapMarker({
  zIndex, active, hover = false, text, onClick
}) {
  const dim = active ? "3.25em" : "2em"
  return (
    <div style={{ fontSize: "16px" }}>
      <div
        style={[
          {
            position: "absolute",
            top: 0,
            left: 0
          },
          zIndex && { zIndex }
        ]}>
        <div
          style={[
            {
              display: active ? "flex" : "block",
              flexDirection: "column",
              alignItems: "center",
              pointerEvents: "none",
              transform: "translate(-50%, -100%)"
            },
            active && { zIndex: "10" }
          ]}>
          {active && (
            <span
              onClick={onClick}
              style={[
                {
                  fontWeight: "600",
                  fontSize: "81%",
                  textTransform: "uppercase",
                  letterSpacing: ".2em",
                  padding: "1em 1.5em",
                  position: "relative",
                  whiteSpace: "nowrap",
                  background: "#fff",
                  marginBottom: "1em",
                  cursor: "pointer",
                  pointerEvents: "initial",
                  border: "1px #d5d5d5 solid"
                }
              ]}>
              {text}
            </span>
          )}
          <PinSvg
            onClick={onClick}
            style={{
              height: dim,
              cursor: "pointer",
              pointerEvents: "initial",
              transition: "all .32s ease-in-out",
              fill: active || hover ? "#910A2D" : "#101010"
            }} />
        </div>
      </div>
    </div>
  )
}

MapMarker.propTypes = {
  zIndex: PropTypes.number,
  animationDelay: PropTypes.number,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  text: PropTypes.string
}

export default Radium(MapMarker)



// WEBPACK FOOTER //
// ./src/components/map-marker/index.jsx